import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { NAV } from "../content/site";

export default function NotFound() {
  return (
    <>
      <Seo path="/404" title="Page not found" />
      <section className="mx-auto max-w-3xl px-4 py-24 sm:px-8" data-testid="not-found-page">
        <p className="font-mono text-sm font-semibold text-primary">404</p>
        <h1 className="mt-4 text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">This page went off-route</h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-brand-slate">
          Unlike our labels, we can't tell you where it went. Here's how to get back on track:
        </p>
        <ul className="mt-10 grid gap-2 sm:grid-cols-2">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} data-testid={`404-link-${n.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="block rounded-sm border border-border px-4 py-3 text-sm font-medium text-brand-navy transition-colors duration-150 hover:border-primary hover:text-primary">
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
